import React from "react";
import { useTrackEvent } from "../../hooks";

function withTrackEvent(Component) {
	return function Wrapper(props) {
		const trackEvent = useTrackEvent();
		return <Component {...props} trackEvent={trackEvent} />;
	};
}

export default withTrackEvent;
